





















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { Itinerario } from '@/api/schema'

@Component({})
export default class RecorridosResultList extends Vue {
  @Prop()
  public results!: Itinerario[]
  @Prop()
  public selectedIndex: number
  @Prop()
  public small: boolean

  public directionRight = true

  public toggleSmallResults() {
    this.$store.dispatch('toggleSmallResultsSearchBus')
  }

  public getNextPage() {
    ;(this as any).$ga.event('resultados', 'more', '', this.results.length / 5)
    this.$store.dispatch('getNextPageSearchBus')
  }

  get resultsLoading() {
    return this.$store.getters.getRecorridosLoadingSearchBus
  }

  get resultsMoreLoading() {
    return this.$store.getters.getResultsMoreLoadingSearchBus
  }

  get resultsMore() {
    return this.$store.getters.getResultsMoreSearchBus
  }

  get hasNextResult() {
    return this.$store.getters.hasNextResultSearchBus
  }

  get hasPrevResult() {
    return this.$store.getters.hasPrevResultSearchBus
  }

  public nextResult() {
    ;(this as any).$ga.event('resultadosSearchBus', 'next', '', this.selectedIndex)
    this.$emit('update:selectedIndex', this.selectedIndex + 1)
    this.directionRight = true
  }
  public prevResult() {
    ;(this as any).$ga.event('resultadosSearchBus', 'prev', '', this.selectedIndex)
    this.$emit('update:selectedIndex', this.selectedIndex - 1)
    this.directionRight = false
  }
}
